import React, { useState, useEffect, useLayoutEffect } from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import CircularProgress from "@mui/material/CircularProgress";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Grid from "@mui/material/Grid";
import EachBusData from "./EachBusData";
import Loading from "./Loading";
import { useHistory } from "react-router-dom";
import Moment from "react-moment";
import moment from "moment";
import AirportShuttleIcon from "@mui/icons-material/AirportShuttle";

// API
import { getAllBuses } from "../../../../actions/buses";
import { getAllTrips } from "../../../../actions/trips";
import { getAllOperatorsClient } from "../../../../actions/operators";

import store from "../../../../store";
import language from "../../../../language";
import SearchFormPackage from "./SearchFormPackage";
import CalenderPackages from "./CalenderPackages";
import SelectBtnSection from "./SelectBtnSection";
import SearchForm from "./SearchForm";

const SearchPackage = () => {
  const history = useHistory();
  const [size, setSize] = useState([0, 0]);
  const [isLoading, setIsLoading] = useState(true);
  const [openModal, setOpenModal] = React.useState(false);
  const [order, setOrder] = React.useState("priceWithout");
  const requestData = useSelector((state) => state?.buses?.requesInfo);
  const departureTripId = useSelector(
    (state) => state?.bookings?.bookingInfo?.departureTripId
  );
  const departureTripDate = useSelector(
    (state) => state?.bookings?.bookingInfo?.departureTripDate
  );
  const departureTripRegularId = useSelector(
    (state) => state?.bookings?.bookingInfo?.departureTripRegularId
  );
  const [miniPriceDeparture, setMiniPriceDeparture] = React.useState();
  const [selectedDepartureDate, setSelectedDepartureDate] =
    React.useState(null);
  const allTrips = useSelector((state) => state?.trips?.allTrips);
  const allPackages = useSelector((state) => state?.trips?.departurePackages);
  const userData = useSelector((state) => state?.userReducer?.userData?.user);
  const allBuses = useSelector((state) => state?.buses?.buses);
  const allOperators = useSelector((state) => state?.operators?.operators);
  const [inputselectedSeats, setInputSelectedSeats] = useState([1]);
  const reqdata = useSelector((state) => state?.buses?.requesInfo);
  const initialHide = typeof window !== "undefined" && window.innerWidth <= 600;
  const [hideContent, setHideContent] = useState(initialHide);
  const [loaddepartureTrips, setLoaddepartureTrips] = useState(false);
  const oldbooking = useSelector((state) => state?.bookings?.oldBooking);
  const modifyTrip = useSelector(
    (state) => state?.buses?.requesInfo?.modifyTrip
  );

  useEffect(() => {
    setLoaddepartureTrips(false);
  }, [allPackages]);

  useEffect(() => {
    let timer;
    if (isLoading) {
      timer = setTimeout(() => {
        setIsLoading(false);
      }, 2000); // 2 seconds
    }
    return () => clearTimeout(timer);
  }, [isLoading]);

  const handleChange = (event) => {
    setOrder(event.target.value);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  useEffect(() => {
    store.dispatch(getAllBuses());
    store.dispatch(getAllTrips());
    store.dispatch(getAllOperatorsClient());
  }, []);

  function useWindowSize() {
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener("resize", updateSize);
      updateSize();
      return () => window.removeEventListener("resize", updateSize);
    }, []);
    return size;
  }

  useWindowSize();

  let languageSelectedEnglish =
    sessionStorage.getItem("language") === "english" ||
    !sessionStorage.getItem("language")
      ? true
      : false;

  const ensureArray = (arr) => (Array.isArray(arr) ? arr : []);

  const getFilteredPackages = (packages, id) =>
    ensureArray(packages).filter((eachpackage) => eachpackage._id === id);

  const getPackageDetails = (packages) =>
    packages?.map((eachpackage) => {
      const currentBus = eachpackage?.busId;
      const currentOperator = allOperators?.find(
        (operator) => operator?._id === eachpackage?.operatorId
      );
      return {
        trip: eachpackage,
        currentBus,
        currentOperator,
      };
    });

  const sortTrips = (trips, order) =>
    trips?.sort((a, b) => {
      if (order === "earliest") {
        return new Date(a.trip.departureTime) - new Date(b.trip.departureTime);
      } else if (order === "latest") {
        return new Date(b.trip.departureTime) - new Date(a.trip.departureTime);
      } else if (order === "priceWithout") {
        const priceDiff = a.trip.priceWithout - b.trip.priceWithout;
        return priceDiff !== 0
          ? priceDiff
          : new Date(a.trip.departureTime) - new Date(b.trip.departureTime);
      }
      return 0;
    }) || [];

  const sortedPackages = sortTrips(getPackageDetails(allPackages), order);

  useEffect(() => {
    if (sortedPackages.length > 0) {
      const prices = sortedPackages.map((item) => item.trip.priceWithout);
      const minPrice = Math.min(...prices);
      setMiniPriceDeparture(minPrice);
    }
  }, [sortedPackages]);

  useEffect(() => {
    if (reqdata?.totalPassenger) {
      // Fill array with seat numbers or leave it as empty values (undefined)
      const seatArray = Array.from(
        { length: reqdata.totalPassenger },
        (_, i) => i + 1
      );
      setInputSelectedSeats(seatArray); // Set array with length based on totalPassenger
    }
  }, [reqdata]);

  const ContinueTrip = () => {
    if (!departureTripId) {
      Swal.fire({
        icon: "error",
        title: "Missing Trips",
        text: "Please select both departure and return trips",
      });
    } else {
      let dataSenderinput = {
        noOfSeats: inputselectedSeats,
        seats: null,
        phone: userData?.phone,
        email: userData?.email,
        price: null,
        // passengerDetails: araydata,
      };

      history.push({
        pathname: "/client/passenger-detail",
        state: dataSenderinput,
      });
    }
  };

  // useEffect(() => {
  //     const handleResize = () => {
  //         setHideContent(window.innerWidth <= 600);
  //     };
  //     handleResize();
  //     window.addEventListener("resize", handleResize);
  //     return () => window.removeEventListener("resize", handleResize);
  // }, []);

  const getFormattedDuration = (departureTime, arrivalTime) => {
    let dep = moment(departureTime, "HH:mm");
    let arr = moment(arrivalTime, "HH:mm");

    if (arr.isBefore(dep)) {
      arr = arr.add(1, "days");
    }

    const duration = moment.duration(arr.diff(dep));
    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();

    return `${hours}:${minutes.toString().padStart(2, "0")}`;
  };

  return (
    <>
      {isLoading ? (
        <div className="result-loading">
          <Loading />
        </div>
      ) : (
        <>
          <div className="search-current ">
            <button
              type="submit"
              className="form-submit-button inforSectionChange"
              onClick={() => setHideContent((prevState) => !prevState)}
            >
              Modify Search
            </button>
            {!hideContent && (
              <SearchForm
                setIsLoading={setIsLoading}
                setHideContent={setHideContent}
              />
            )}
          </div>
          {/* {!departureTripId && ( */}
          <CalenderPackages
            allTrips={allTrips}
            setSelectedDepartureDate={setSelectedDepartureDate}
            route2={requestData?.to}
            route1={requestData?.from}
            Date={requestData?.departureDate}
            miniPriceDeparture={miniPriceDeparture}
            setLoaddepartureTrips={setLoaddepartureTrips}
          />
          {/* )} */}
          <Grid
            container
            className="result"
            justifyContent="space-between"
            style={{ margin: "10px 0" }}
          >
            <Grid
              item
              xs={12}
              align="center"
              // className={` ${
              //   !departureTripId ? "sortingsectionMain" : "sortingsectionMain1"
              // } `}
              className="sortingsectionMain"
            >
              {/* {!departureTripId && */}
              <div className="spposeDiv"></div>
              {/* } */}
              <div className="inforHomeOuter">
                <span className="SelectPackageText">
                  Select your Package below:
                </span>
                <div className="fromtoCity">
                  <span className="to-fro-cities">{requestData?.from}</span>
                  <span className="to-text">To</span>
                  <span className="to-fro-cities">{requestData?.tripType}</span>
                </div>
              </div>
              {/* {!departureTripId && ( */}
              <div className="sortingSection">
                <div className="sortbyText">Sort by</div>
                <Select
                  value={order}
                  onChange={(e) => handleChange(e)}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  className="sortingSelect"
                >
                  <MenuItem value="earliest">Earliest departure</MenuItem>
                  <MenuItem value="latest">Latest departure</MenuItem>
                  <MenuItem value="priceWithout">Price</MenuItem>
                </Select>
              </div>
              {/* )} */}
            </Grid>
            <Grid
              item
              xl={2}
              lg={2}
              md={3}
              sm={12}
              xs={12}
              style={{
                background: "#fff",
                boxShadow:
                  "2px 2px 8px -3px rgb(0 0 0 / 40%), -2px -2px 8px -3px rgb(0 0 0 / 40%)",
                padding: "20px",
                borderRadius: "10px",
                margin: "30px 0",
                paddingBottom: "30px",
              }}
              className="filterSection"
            >
              <h2 className="filterTxtHeading">
                {languageSelectedEnglish ? "Filter" : language.filter}
              </h2>
              <h5 className="subHeadingFilter">
                {languageSelectedEnglish ? "Bus Type" : language.busType}
              </h5>
              <Grid item xs={12}>
                <Grid item xs={12} style={{ margin: "10px 0" }}>
                  <input type="checkbox" />
                  <label
                    style={{ marginLeft: "10px" }}
                    className="filterTypeTxt"
                  >
                    {languageSelectedEnglish
                      ? "Executive Class"
                      : language.executiveClass}
                  </label>
                </Grid>
                <Grid item xs={12} style={{ margin: "10px 0" }}>
                  <input type="checkbox" />
                  <label
                    style={{ marginLeft: "10px" }}
                    className="filterTypeTxt"
                  >
                    {languageSelectedEnglish
                      ? "Business Class"
                      : language.businessClass}
                  </label>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <h5 style={{ marginTop: "20px" }} className="subHeadingFilter">
                  {languageSelectedEnglish ? "Operators" : language.operators}
                </h5>
                <Grid item xs={12} style={{ margin: "10px 0" }}>
                  <input type="checkbox" />
                  <label
                    style={{ marginLeft: "10px" }}
                    className="filterTypeTxt"
                  >
                    Faisal Movers
                  </label>
                </Grid>
                <Grid item xs={12} style={{ margin: "10px 0" }}>
                  <input type="checkbox" />
                  <label
                    style={{ marginLeft: "10px" }}
                    className="filterTypeTxt"
                  >
                    Daewoo Express
                  </label>
                </Grid>
              </Grid>
            </Grid>
            {/* <Grid
                            item
                            xl={9.7}
                            lg={9.7}
                            md={8}
                            sm={12}
                            xs={12}
                            style={{
                                borderRadius: "10px",
                                overflowX: "scroll",
                                margin: "30px 0",
                                gap: "20px",
                                padding: "10px"
                            }}
                            className={`${sortedPackages?.length == 0 ? 'tripboxShad' : ''}`}
                        >
                            {loaddepartureTrips && <div className="loaderSection"><CircularProgress sx={{ color: '#c99a3c' }} /></div>}
                            {!loaddepartureTrips && (sortedPackages?.length > 0 ? (
                                sortedPackages.map((data, index) => (
                                    <Grid

                                        style={{
                                            minWidth: "1000px", width: "fit-content", marginBottom: "20px",
                                        }}
                                        className="topBusListingSearchedRes"
                                    >
                                        <Grid
                                            container
                                            className="ListingWrapper"
                                            style={{
                                                backgroundColor: "#f5f5f5",
                                                borderTop: "1px solid #dee2e6",
                                                borderBottom: "1px solid #dee2e6",
                                                padding: "10px",
                                                display: "flex",
                                                flexWrap: "nowrap",
                                                alignItems: "center",
                                                gap: "10px"
                                            }}
                                        >
                                            <Grid className="Listings packageItemsTitles">
                                                <p className="headingBusListing">
                                                    {languageSelectedEnglish
                                                        ? "Bus Operator"
                                                        : language.operators}
                                                </p>
                                            </Grid>
                                            <Grid className="Listings packageItemsTitles">
                                                <p className="headingBusListing">
                                                    {languageSelectedEnglish
                                                        ? "Package ID"
                                                        : language.operators}
                                                </p>
                                            </Grid>
                                            <Grid className="Listings packageItemsTitles">
                                                <p className="headingBusListing">
                                                    {languageSelectedEnglish
                                                        ? "Departure"
                                                        : language.departure}
                                                </p>
                                            </Grid>
                                            <Grid className="Listings packageItemsTitles">
                                                <p className="headingBusListing">
                                                    {languageSelectedEnglish
                                                        ? "Duration"
                                                        : language.duration}
                                                </p>
                                            </Grid>
                                            <Grid className="Listings packageItemsTitles">
                                                <p className="headingBusListing">
                                                    {languageSelectedEnglish
                                                        ? "Arrival"
                                                        : language.arrival}
                                                </p>
                                            </Grid>
                                            <Grid className="Listings packageItemsTitles">
                                                <p className="headingBusListing">
                                                    {languageSelectedEnglish
                                                        ? "No. of Days"
                                                        : language.arrival}
                                                </p>
                                            </Grid>
                                            <Grid className="Listings packageItemsTitles">
                                                <p className="headingBusListing">
                                                    {languageSelectedEnglish
                                                        ? "Bus Plate Number"
                                                        : language.busPlateNumber}
                                                </p>
                                            </Grid>
                                            <Grid className="Listings packageItemsTitles">
                                                <p className="headingBusListing">
                                                    {languageSelectedEnglish
                                                        ? "Bus Type"
                                                        : language.price}
                                                </p>
                                            </Grid>
                                            <Grid className="Listings packageItemsTitles">
                                                <p className="headingBusListing">
                                                    {languageSelectedEnglish
                                                        ? "Available Seats"
                                                        : language.availableSeats}
                                                </p>
                                            </Grid>
                                            <Grid className="Listings packageItemsTitles">
                                                <p className="headingBusListing">
                                                    {languageSelectedEnglish
                                                        ? "Baggage Allowance"
                                                        : language.theBaggage}
                                                </p>
                                            </Grid>
                                            <Grid className="Listings packageItemsTitles">
                                                <p className="headingBusListing">
                                                    {languageSelectedEnglish
                                                        ? "Return Departure"
                                                        : language.departure}
                                                </p>
                                            </Grid>
                                            <Grid className="Listings packageItemsTitles">
                                                <p className="headingBusListing">
                                                    {languageSelectedEnglish
                                                        ? "Duration"
                                                        : language.duration}
                                                </p>
                                            </Grid>
                                            <Grid className="Listings packageItemsTitles">
                                                <p className="headingBusListing">
                                                    {languageSelectedEnglish
                                                        ? "Return Arrival"
                                                        : language.arrival}
                                                </p>
                                            </Grid>
                                        </Grid>

                                        <EachBusData
                                            key={index}
                                            trip={data.trip}
                                            handleOpenModal={handleOpenModal}
                                            bus={data.currentBus}
                                            operator={data.currentOperator}
                                            selectedDepartureDate={selectedDepartureDate}
                                            tripType="Departure"
                                            departureTripId={departureTripId}
                                            allBuses={allBuses}
                                            departureTripDate={departureTripDate}
                                            oldbooking={oldbooking} // Pass the oldtripId
                                            modifyTrip={modifyTrip}
                                            isPackage={true}
                                        />

                                    </Grid>
                                ))
                            ) : (
                                <p className="noTripsText">No packages available</p>
                            ))}
                        </Grid> */}

            <Grid
              item
              xl={9.7}
              lg={9.7}
              md={8}
              sm={12}
              xs={12}
              style={{
                borderRadius: "10px",
                overflowX: "scroll",
                margin: "30px 0",
                gap: "20px",
                padding: "10px",
              }}
              className={`${sortedPackages?.length == 0 ? "tripboxShad" : ""}`}
            >
              {loaddepartureTrips && (
                <div className="loaderSection">
                  <CircularProgress sx={{ color: "#c99a3c" }} />
                </div>
              )}
              {!loaddepartureTrips &&
                (sortedPackages?.length > 0 ? (
                  sortedPackages.map((data, index) => {
                    // ✅ Use helper function
                    const tripDuration = getFormattedDuration(
                      data?.trip?.departureTime,
                      data?.trip?.arrivalTime
                    );

                    // Example if you have a second duration (e.g., return trip or layover)
                    const secondDuration = getFormattedDuration(
                      data?.trip?.returnDepartureTime,
                      data?.trip?.returnArrivalTime
                    );

                    const baseDate =
                      data?.trip?.packageDate !== ""
                        ? data?.trip.packageDate
                        : selectedDepartureDate;

                    // Add numberOfDays to baseDate
                    const packageReturnDate = moment(baseDate)
                      .add(data?.trip?.numberOfDays || 0, "days")
                      .format("YYYY-MM-DD");

                    return (
                      <Grid
                        item
                        xs={12}
                        sx={{
                          minWidth: { xs: "100%", md: "1000px" },
                          width: { xs: "100%", md: "fit-content" },
                          marginBottom: "20px",
                        }}
                        className="topBusListingSearchedRes"
                      >
                        <Grid container className="ListingWrapper">
                          <div className="eachTripItemOuter">
                            <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                              <p className="headingBusListing">Bus Operator</p>
                            </div>
                            <div
                              className="result-each-data-name lowerdescript packageItemsTitles"
                              flexDirection="column"
                            >
                              <p className="tripIdp">
                                {data?.currentOperator?.companyname}
                              </p>
                            </div>
                          </div>
                          <div className="eachTripItemOuter">
                            <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                              <p className="headingBusListing">Package ID</p>
                            </div>
                            <div
                              className="result-each-data-name packageItemsTitles"
                              flexDirection="column"
                            >
                              <p className="tripIdp">
                                {data?.trip?.packageAlphaId}
                              </p>
                            </div>
                          </div>

                          <div className="eachTripItemOuter">
                            <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                              <p className="headingBusListing">
                                {languageSelectedEnglish
                                  ? "No. of Days"
                                  : language.busPlateNumber}
                              </p>
                            </div>
                            <div className="packageItemsTitles">
                              <p className="tripIdp">
                                {data?.trip?.numberOfDays}
                              </p>
                            </div>
                          </div>

                          <div className="eachTripItemOuter">
                            <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                              <p className="headingBusListing">Departure</p>
                            </div>
                            <div
                              className="result-each-data-departure packageItemsTitles"
                              flexDirection="column"
                            >
                              <span className="result-each-data-departure-time dispolayFlexDown">
                                <div className="tripIdp">
                                  {" "}
                                  {data?.trip?.departureTime}
                                </div>
                                <Moment className="tripIdp" format="MM/DD/YYYY">
                                  {data?.trip?.packageDate
                                    ? data?.trip.packageDate
                                    : selectedDepartureDate}
                                </Moment>
                                <span className="result-each-data-departure-place tripIdp">
                                  {data?.trip?.routeFrom}
                                </span>
                                <div className="departadress">
                                  {" "}
                                  {data?.trip?.departureAddress}
                                </div>
                              </span>
                            </div>
                          </div>
                          <div className="eachTripItemOuter">
                            <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                              <p className="headingBusListing">
                                {languageSelectedEnglish
                                  ? "Duration"
                                  : language.duration}
                              </p>
                            </div>
                            <div className="packageItemsTitles">
                              <div className="durationDiv">
                                <span className="result-each-data-total-time durationp tripIdp">
                                  {tripDuration} hours
                                </span>

                                <div className="durationDiv2">
                                  <div className="durationDiv1">
                                    <span className="durationSpan1"></span>
                                    <span className="durationSpan2"></span>
                                  </div>
                                  <AirportShuttleIcon className="busIcon" />
                                  <div className="durationDiv3">
                                    <span className="durationSpan2"></span>
                                    <span className="durationSpan1"></span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="eachTripItemOuter">
                            <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                              <p className="headingBusListing">
                                {languageSelectedEnglish
                                  ? "Arrival"
                                  : language.arrival}
                              </p>
                            </div>
                            <div
                              className="result-each-data-arrival packageItemsTitles"
                              flexDirection="column"
                            >
                              <span className="result-each-data-arrival-time dispolayFlexDown">
                                <div className="tripIdp">
                                  {data?.trip?.arrivalTime}
                                </div>
                                <Moment className="tripIdp" format="MM/DD/YYYY">
                                  {data?.trip?.packageDate
                                    ? data?.trip.packageDate
                                    : selectedDepartureDate}
                                </Moment>
                                <span className="result-each-data-arrival-place tripIdp">
                                  {data?.trip?.routeTo}
                                </span>
                                <div className="departadress">
                                  {" "}
                                  {data?.trip?.arrivalAddress}
                                </div>
                              </span>
                            </div>
                          </div>

                          <div className="eachTripItemOuter">
                            <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                              <p className="headingBusListing">
                                {languageSelectedEnglish
                                  ? "Bus Plate Number"
                                  : language.busPlateNumber}
                              </p>
                            </div>
                            <div className="packageItemsTitles">
                              <p className="tripIdp">
                                {data?.currentBus?.busNumber}
                              </p>
                            </div>
                          </div>

                          <div className="eachTripItemOuter">
                            <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                              <p className="headingBusListing">
                                {languageSelectedEnglish
                                  ? "Bus Type"
                                  : language.price}
                              </p>
                            </div>
                            <div className="packageItemsTitles">
                              <p className="tripIdp">
                                {data?.currentBus?.busType}
                              </p>
                            </div>
                          </div>

                          <div className="eachTripItemOuter">
                            <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                              <p className="headingBusListing">
                                {languageSelectedEnglish
                                  ? "Available Seats"
                                  : language.availableSeats}
                              </p>
                            </div>
                            <div
                              className="result-each-data-extra packageItemsTitles"
                              flexDirection="column"
                            >
                              <span className="result-each-data-extra-available tripIdp">
                                {data?.trip?.availableSeats}
                                Available
                              </span>
                            </div>
                          </div>

                          <div className="eachTripItemOuter">
                            <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                              <p className="headingBusListing">
                                Return Departure
                              </p>
                            </div>
                            <div
                              className="result-each-data-departure packageItemsTitles"
                              flexDirection="column"
                            >
                              <span className="result-each-data-departure-time dispolayFlexDown">
                                <div className="tripIdp">
                                  {" "}
                                  {data?.trip?.returnDepartureTime}
                                </div>
                                <Moment className="tripIdp" format="MM/DD/YYYY">
                                  {packageReturnDate}
                                </Moment>
                                <span className="result-each-data-departure-place tripIdp">
                                  {data?.trip?.returnDepartureCity}
                                </span>
                                <div className="departadress">
                                  {" "}
                                  {data?.trip?.arrivalAddress}
                                </div>
                              </span>
                            </div>
                          </div>
                          <div className="eachTripItemOuter">
                            <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                              <p className="headingBusListing">Duration</p>
                            </div>
                            <div className="packageItemsTitles">
                              <div className="durationDiv">
                                <span className="result-each-data-total-time durationp tripIdp">
                                  {secondDuration} hours
                                </span>

                                <div className="durationDiv2">
                                  <div className="durationDiv1">
                                    <span className="durationSpan1"></span>
                                    <span className="durationSpan2"></span>
                                  </div>
                                  <AirportShuttleIcon className="busIcon" />
                                  <div className="durationDiv3">
                                    <span className="durationSpan2"></span>
                                    <span className="durationSpan1"></span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="eachTripItemOuter">
                            <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                              <p className="headingBusListing">
                                Return Arrival
                              </p>
                            </div>
                            <div
                              className="result-each-data-arrival packageItemsTitles"
                              flexDirection="column"
                            >
                              <span className="result-each-data-arrival-time dispolayFlexDown">
                                <div className="tripIdp">
                                  {data?.trip?.returnArrivalTime}
                                </div>
                                <Moment className="tripIdp" format="MM/DD/YYYY">
                                  {packageReturnDate}
                                </Moment>
                                <span className="result-each-data-arrival-place tripIdp">
                                  {data?.trip?.returnArrivalCity}
                                </span>
                                <div className="departadress">
                                  {" "}
                                  {data?.trip?.departureAddress}
                                </div>
                              </span>
                            </div>
                          </div>
                          <div className="eachTripItemOuter">
                            <div className="Listings packageItemsTitles uperdescript eachTripInnerHeading">
                              <p className="headingBusListing">
                                {languageSelectedEnglish
                                  ? "Baggage Allowance"
                                  : language.theBaggage}
                              </p>
                            </div>
                            <div
                              className="result-each-data-extra packageItemsTitles"
                              flexDirection="column"
                            >
                              <span className="result-each-data-extra-available tripIdp">
                                <span className="bold">
                                  {data?.currentBus?.baggage}
                                </span>{" "}
                                pieces
                              </span>
                            </div>
                          </div>
                        </Grid>
                        <SelectBtnSection
                          key={index}
                          trip={data.trip}
                          handleOpenModal={handleOpenModal}
                          bus={data.currentBus}
                          operator={data.currentOperator}
                          selectedDepartureDate={selectedDepartureDate}
                          tripType="Departure"
                          departureTripId={departureTripId}
                          allBuses={allBuses}
                          departureTripDate={departureTripDate}
                          oldbooking={oldbooking}
                          modifyTrip={modifyTrip}
                          isPackage={true}
                        />
                      </Grid>
                    );
                  })
                ) : (
                  <p>No package available</p>
                ))}
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default SearchPackage;
